import { render, staticRenderFns } from "./BoletinPeriodoGustavoRojas.vue?vue&type=template&id=5fa22ebf&scoped=true&"
import script from "./BoletinPeriodoGustavoRojas.vue?vue&type=script&lang=js&"
export * from "./BoletinPeriodoGustavoRojas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fa22ebf",
  null
  
)

export default component.exports